/* eslint-disable prettier/prettier */
"use client";

import { Text } from "@dxp-feed/ui/Text";
import { Checkbox } from "@dxp-feed/ui/Checkbox";
import {
  useAppDispatch,
  useAppSelector,
  useState,
  useEffect,
} from "@/utils/hooks/reactUseCustomHooks";
import { Badge } from "@dxp-feed/ui/Badge";
import { Separator } from "@dxp-feed/ui/Separator";
import { Button } from "@dxp-feed/ui/Button";
import CreateRecipesList from "./CreateRecipesList";
import { createRecipeToListAction } from "@/utils/redux/recipes/addtolistSlice/actions";
import { Box } from "@dxp-feed/ui/Box";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "@dxp-feed/ui/Dialog";
import useFavorites from "../common/commonRecipeFunctions/useFavourites";
import React from "react";
import { Tooltip } from "@dxp-feed/ui/Tooltip";
import { LayerDataType } from "@/utils/types/recipes";
import { addRecipeToListDataLeyarFun, removeToListDataLeyarFun } from "../common/commonRecipeFunctions/dataLayer";
import { getfetchFavouritesRecipes } from "@/utils/redux/recipes/recipeSlice/actions";
import { setToastMessage } from "@/utils/redux/recipes/toastMessageSlice";
import useNetwork from "../common/commonRecipeFunctions/useNetwork";
import { useGigyaToken } from "../common/commonRecipeFunctions/getGigyaToken";
import Loader from "@/components/Loader";
import { useGigyaAccountInfo } from "@/helpers/gigyaCentralSsoHook";
import { setFavourites, setRecipeList } from "@/utils/redux/recipes/addtolistSlice";
import { mealPlanDefautMessage, recipeModalData } from "@/utils/aemDefaultData";

const FavouriteRecipe = ({
  recipeData,
  list_name,
  FavouritesData,
  setIsModalOpen,
  isModalOpen,
  favLoading = false,
}: {
  recipeData: any;
  list_name: string;
  FavouritesData: any[];
  setIsModalOpen: any;
  isModalOpen: any;
  favLoading: boolean;
}) => {
  const [checked, setChecked] = useState<any>([]);
  const [firstChecked, setFirstChecked] = useState<string[]>([]);
  const [hideModal, setHideModal] = useState(false);
  const [selectRecipe, setSelectRecipe] = useState<any>([]);
  const [layerData, setLayerData] = useState<LayerDataType>({
    addTolist: [],
    removeToList: [],
  });
  const dispatch = useAppDispatch();
  const isOnline = useNetwork();
  const { resetLoginParams } = useGigyaToken();
  const gigyaToken = useGigyaAccountInfo(); 
  const { uid: Uid } = useAppSelector((state) => state.gigyaslice);
  const { recipeList , favourite} = useAppSelector((state) => state.RecipeToList);
  const { messages: MESSAGE } = useAppSelector((state) => state.messageSlice);
  const { closeFavourite }: any = useFavorites();
  const { aemRecipeModelData: aemModalData } = useAppSelector(
    (state) => state.AemModalSlice
  );

  // console.log("recipeList :",recipeList);

  useEffect(() => {
    if (Uid && recipeList && recipeData?.objectID) {
      const recipeId = recipeData.objectID;
  
      const listIds = recipeList
        .filter((list: any) =>
          list.recipes?.some((r: any) => r.recipe_id === recipeId)
        )
        .map((list: any) => list.id);
  
      const favMatch = favourite?.recipes?.some(
        (r: any) => r.recipe_id === recipeId
      );
  
      const finalChecked = favMatch && favourite?.id
        ? [...listIds, favourite.id]
        : listIds;
  
      setChecked(finalChecked);
      setFirstChecked(finalChecked);
    }
  }, [Uid, recipeList, favourite?.id, favourite?.recipes, recipeData?.objectID]);
  


  const closeModal = () => {
    setIsModalOpen(false);
    setChecked([]);
    closeFavourite();
  };

  const addAndRemoveDataLayer = async (
    isAdded: boolean,
    recipe_list_name: string
  ) => {
    const data = {
      event: isAdded ? "add_recipe_to_list" : "remove_recipe_from_list",
      recipe_name: recipeData?.title,
      list_name: list_name,
      recipe_list_name: recipe_list_name,
      page_title: document.title,
    };

    if (isAdded) {
      const updatedList = layerData.removeToList.filter((item) => item.recipe_list_name !== recipe_list_name)
      const exists = layerData.removeToList?.some((item) => item.recipe_list_name === recipe_list_name);
      setLayerData((prevData) => ({
        ...prevData,
        addTolist: !exists ? [...prevData.addTolist, data] : [...prevData.addTolist],
        removeToList: updatedList
      }));
    } else {
      const exists = layerData.addTolist?.some((item) => item.recipe_list_name === recipe_list_name);
      const updatedList =layerData.addTolist?.filter((item) => item.recipe_list_name !== recipe_list_name)
      setLayerData((prevData) => ({
        ...prevData,
        removeToList: !exists ? [...prevData.removeToList, data] : [...prevData.removeToList],
        addTolist: updatedList
      }));
    }
    
  };

  const handleCheckboxChange = (listId: string, isChecked: boolean) => {
    setSelectRecipe([...selectRecipe, listId]);
    setChecked((prev: any) => {
      if (isChecked) {
        return [...prev, listId]; // Add the ID to the array if checked
      } else {
        return prev.filter((id: any) => id !== listId);
      }
    });
  };

  const validateCheckedRecipes = (Message: any) => {
    if (Message) {
      dispatch(setToastMessage({
        message: MESSAGE?.RECIPE_LIST_UPDATE ?? mealPlanDefautMessage[0]?.recipeListUpdate,
        status: "success",
        messageOf: "recipe"
      }));
    }
    else if (checked.length > firstChecked.length) {
      dispatch(setToastMessage({
        message: MESSAGE?.RECIPE_ADDED_TO_LIST ?? mealPlanDefautMessage[0]?.recipeSuccessfulAdd ,
        status: "success",
        messageOf: "recipe"
      }));
    } else if (checked.length === firstChecked.length) {
      const elementsMatch: string[] = checked.every((item: string) =>
        firstChecked.includes(item)
      );
      if (!elementsMatch) {
        dispatch(setToastMessage({
          message: MESSAGE?.RECIPE_ADDED_TO_LIST ?? mealPlanDefautMessage[0]?.recipeSuccessfulAdd,
          status: "success",
          messageOf: "recipe"
        }));
      }
    } else if (checked.length < firstChecked.length) {
      const anyNotInFirstChecked = checked?.some(
        (item: string) => !firstChecked.includes(item)
      );
      if (anyNotInFirstChecked) {
        dispatch(setToastMessage({
          message: MESSAGE?.RECIPE_ADDED_TO_LIST ?? mealPlanDefautMessage[0]?.recipeSuccessfulAdd,
          status: "success",
          messageOf: "recipe"
        }));
      } else {
        dispatch(setToastMessage({
          message: MESSAGE?.RECIPE_REMOVE_TO_LIST ?? mealPlanDefautMessage[0]?.recipeSuccessfulRemoval,
          status: "success",
          messageOf: "recipe"
        }));
      }
    }
  };

  const addRecipeTolist = async () => {
    /** Check if User is online */
    if (!isOnline) {
      dispatch(
        setToastMessage({
          message: `${MESSAGE?.ERROR_MESSAGE?.OFFLINE_ERROR ?? mealPlanDefautMessage[0]?.offlineError}`,
          status: "",
        })
      );
      return;
    }
    console.log("recipeData.objectID :", recipeData.objectID)
    const arrayOfObjects = selectRecipe.map((listId: any) => ({
      recipe_id: recipeData.objectID,
      list_id: listId,
      type: "",
    }));
    const { idToken: token } = await gigyaToken();
    const payload ={
      token,
      recipes: arrayOfObjects,
    };

    const result = await dispatch(createRecipeToListAction(payload));
    if (result?.payload?.status == 401) {
      resetLoginParams();
      return;
    }

    const isFavouritePresent = arrayOfObjects.find((obj:any) => obj?.list_id == favourite?.id);

    if(isFavouritePresent){
      const matched = favourite.recipes.find((obj:any)=> obj.recipe_id == isFavouritePresent.recipe_id)
      if(matched){
        const enrichedFavourites = {
          ...favourite,
          recipes: favourite.recipes.filter(
            (recipe: any) => recipe.recipe_id !== isFavouritePresent.recipe_id
          ),
        };
        dispatch(setFavourites(enrichedFavourites));
      }else{
        const enrichedFavourites = {
          ...favourite,
          recipes: [...favourite.recipes,{recipe_id :isFavouritePresent.recipe_id}]
      }
      dispatch(setFavourites(enrichedFavourites));
      }
    }
    const updatedRecipeList = recipeList.map((list: any) => {
      // Find all items in arrayOfObjects that belong to this list
      const listActions = arrayOfObjects.filter(
        (item: any) => item.list_id === list.id
      );

    
      if (listActions.length === 0) return list;
    
      // Clone current list's recipes
      let updatedRecipes = [...list.recipes];
    
      for (const action of listActions) {
        const exists = updatedRecipes.some(
          (r: any) => r.recipe_id === action.recipe_id
        );
    
        if (exists) {
          // Remove recipe_id if already present
          updatedRecipes = updatedRecipes.filter(
            (r: any) => r.recipe_id !== action.recipe_id
          );
        } else {
          // Add recipe_id if not present
          updatedRecipes.push({ recipe_id: action.recipe_id });
        }
      }
    
      return {
        ...list,
        recipes: updatedRecipes,
      };
    });

    dispatch(setRecipeList(updatedRecipeList))
    



    if (layerData?.addTolist.length) {
      addRecipeToListDataLeyarFun(layerData.addTolist);
    }

    if (layerData?.removeToList.length) {
      removeToListDataLeyarFun(layerData.removeToList);
    }
    setSelectRecipe([]);
    closeModal();
    closeFavourite();
    // if(Uid){
    //   const resultFav = await dispatch(
    //     getfetchFavouritesRecipes({ token })
    //   );
    //   if (resultFav?.payload?.status == 401) {
    //     resetLoginParams();
    //     return;
    //   }
    // }
    validateCheckedRecipes(layerData?.addTolist.length && layerData?.removeToList.length);
    setLayerData({
      addTolist: [],
      removeToList: [],
    });
  };

  const closeAllModal = () => {
    closeModal();
    setHideModal(false);
  };

  const hideAddToFavModal = () => {
    setHideModal(true);
  };
  return (
    <Dialog
      isOpen={isModalOpen}
      onClose={closeModal}
      closeOnOverlayClick={false}
      className={`max-w-full md:max-w-[708px] rounded-none md:rounded-lg p-0 outline-none ${hideModal && "hidden"}`}
      positionClass={`items-end md:items-center  `}
    >
      {favLoading ? (
        <>
          <DialogHeader className="border-grey250 border-b-2 py-6 md:py-4 px-6">
            <label htmlFor="Type here" className="sr-only">
                {aemModalData?.placeholderText ?? recipeModalData[0]?.placeholderText}
            </label>
            <Box as="div" className="text-[16px] font-bold">
              {aemModalData?.chooseRecipeList ?? recipeModalData[0]?.chooseRecipeList}
            </Box>
          </DialogHeader>
          <Loader />
        </>
      ) : (
        <>
          <DialogHeader className="border-neutral300 border-b-2 py-6 md:py-4 px-6">
            <label htmlFor="Type here" className="sr-only">
                {aemModalData?.placeholderText ?? recipeModalData[0]?.placeholderText}
            </label>
            <Box as="div" className="text-[16px] font-bold">
              {aemModalData?.chooseRecipeList ?? recipeModalData[0]?.chooseRecipeList}
            </Box>
            <Button
              className="text-brandSecondary font-bold text-lg h-[24px] rounded-none"
              onClick={closeModal}
              aria-label="Close modal"
              variant="icon"
              size="none"
            >
              <Text
                as="span"
                className="demo-icon icon-close text-brandBlack text-[14px] "
              ></Text>
            </Button>
          </DialogHeader>
          <DialogBody className="px-6 py-2 md:py-4 max-h-[262px] md:max-h-[270px] overflow-y-auto">
            {favourite ? (
              <FavouriteList
                checked={checked}
                favourite={favourite}
                handleCheckboxChange={handleCheckboxChange}
                addAndRemoveDataLayer={addAndRemoveDataLayer}
                FavouritesData={FavouritesData}
                aemModalData={aemModalData}
                recipeList={recipeList}
              />
            ) : null}

            {recipeList &&
              recipeList.length > 0 &&
              recipeList.map((item: any, index: any) => (
                <React.Fragment key={item.list_name + index}>
                  <Text as="span" className="relative group flex items-center">
                    <Text as="label" className="flex items-center text-[14px]">
                      <Text
                        as="span"
                        className="w-12 h-12 flex items-center justify-center "
                      >
                        <Checkbox
                          checked={checked.includes(item.id)}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            handleCheckboxChange(item.id, isChecked);
                            void addAndRemoveDataLayer(
                              isChecked,
                              item.list_name
                            );
                          }}
                          className="checked:before:bg-grey900 before:border-grey900 checked:after:bg-grey900"
                        />
                      </Text>
                      <Text as="span">
                        {`${item?.list_name} (${item?.recipes?.length ?? 0})`}
                        {item?.badge && (
                          <Badge
                            variant="secondary"
                            className="ml-3 bg-[rgba(122, 122, 122, 0.12)] rounded-md text-[12px]"
                          >
                            {item?.badge}
                          </Badge>
                        )}
                      </Text>
                    </Text>
                  </Text>
                  {index < recipeList.length - 1 && (
                    <Separator
                      orientation="horizontal"
                      className="bg-grey250 !h-[2px] my-2"
                    />
                  )}
                </React.Fragment>
              ))}
          </DialogBody>
          <DialogFooter className="border-grey250 border-t-2 py-6 md:py-4 pt-4 px-6">
            <Box
              as="div"
              className="flex flex-col 2xs:flex-row w-full justify-center xs:justify-between gap-6"
            >
              <Box
                as="div"
                className="flex w-full justify-center xs:justify-start "
              >
                {/** changes */}
                <CreateRecipesList
                  recipeData={recipeData}
                  recipeList={recipeData}
                  closeAllModal={closeAllModal}
                  hideAddToFavModal={hideAddToFavModal}
                />
              </Box>
              <Box
                as="div"
                className="flex w-full justify-center xs:justify-end"
              >
                <Button
                  variant="primary"
                  className="border-0 bg-transparent text-[#003D2A] underline decoration-solid [&:hover]:border-0 [&:hover]:bg-transparent 
                  text-[14px] font-bold"
                  onClick={closeModal}
                  aria-label={aemModalData?.cancel ?? recipeModalData[0]?.cancel}
                >
                  {aemModalData?.cancel ?? recipeModalData[0]?.cancel}

                  {/* Cancel */}
                </Button>
                <Button
                  disabled={
                    !(
                      layerData?.addTolist.length ||
                      layerData?.removeToList.length
                    )
                  }
                  onClick={() => addRecipeTolist()}
                  variant="primary"
                  className="ml-2 text-[14px] font-normal h-10 w-auto 2xs:w-[133px] md:w-[83px]"
                  aria-label={aemModalData?.save ?? recipeModalData[0]?.save}
                >
                  {aemModalData?.save ?? recipeModalData[0]?.save}
                  {/* Save */}
                </Button>
              </Box>
            </Box>
          </DialogFooter>
        </>
      )}
    </Dialog>
  );
};

export default FavouriteRecipe;

const FavouriteList = ({
  checked,
  favourite,
  handleCheckboxChange,
  addAndRemoveDataLayer,
  FavouritesData,
  aemModalData,
  recipeList
}:{  checked: any[];
  favourite: any;
  handleCheckboxChange: any;
  addAndRemoveDataLayer: any;
  FavouritesData: any;
  aemModalData: any;
  recipeList: any;
}) => {
  return (
    <React.Fragment >
              <Text
                as="span"
                className="relative group flex items-center justify-between bg-[#DCDCDC] rounded-[12px] cursor-not-allowed"
              >
                <Text
                  as="label"
                  className="flex items-center text-[14px] cursor-not-allowed"
                >
                  <Text
                    as="span"
                    className="w-12 h-12 flex items-center justify-center "
                  >
                    <Checkbox
                      checked={checked.includes(favourite.id)}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        handleCheckboxChange(favourite.id, isChecked);
                        addAndRemoveDataLayer(isChecked, favourite.list_name);
                      }}
                      className="checked:before:bg-grey900 before:border-grey900 checked:after:bg-grey900 "
                    />
                  </Text>

                  <Text as="span">
                    {`${favourite?.list_name} (${FavouritesData?.length ?? 0})`}
                      <Badge
                        variant="secondary"
                        className="ml-3 bg-[rgba(122, 122, 122, 0.12)] rounded-md !text-[14px] font-normal py-[6px] px-2 bg-grey900"
                      >
                        {aemModalData?.default ?? recipeModalData[0]?.default}
                      </Badge>
                  </Text>
                </Text>
                <Tooltip
                  content="Favourites is a default recipe list. All recipes added to any list, are also added to favourites."
                  direction="left"
                  arrow
                  className="tab text-[12px] w-[250px] 4xs:w-[290px]"
                  aria-label="Favourites is a default recipe list. All recipes added to any list, are also added to favourites."
                >
                  <Text
                    as="span"
                    className="icon-sponsored text-brandBlack text-[18px] mr-[16px] w-6 h-6 "
                  ></Text>
                </Tooltip>
              </Text>

              {recipeList && recipeList.length > 0 && (
                <Separator
                  orientation="horizontal"
                  className="bg-grey250 !h-[2px] my-2"
                />
              )}
            </React.Fragment>
  )
}